import { connect } from "react-redux";
import { useEffect, useState } from "react";
import {
  check_authenticated,
  load_user,
  login,
  refresh,
} from "../../redux/actions/auth/auth";
import { Navigate } from "react-router-dom";
import img_login from "../../assets/img/img-login.jpg";
import img_logo from "../../assets/img/icon.png";

import Toast from "../../components/Alert";
import { Meta } from "../../components/navigation/Helmet";
import HomeLayout from "../../hocs/layout/HomeLayout";

function Login({
  login,
  isAuthenticated,
  loading,
  refresh,
  check_authenticated,
  load_user,
}) {
  // Corrección: hacer checks en efecto (sin JSX dentro)
  useEffect(() => {
    if (!isAuthenticated) {
      refresh();
      check_authenticated();
      load_user();
    }
  }, [isAuthenticated, refresh, check_authenticated, load_user]);

  // Notificación al autenticarse
  useEffect(() => {
    if (isAuthenticated) {
      Toast({ tipo: "success", mensaje: "Has Iniciado Sesión!" });
    }
  }, [isAuthenticated]);

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const { email, password } = formData;

  const onChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const onSubmit = (e) => {
    e.preventDefault();
    login(email, password);
  };

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <HomeLayout>
      <Meta title="Login" />
      {/* Fondo sutil y centrado absoluto para móvil */}
      <main className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="w-full max-w-5xl mx-auto p-4">
          {/* Card responsiva */}
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100">
            <div className="grid grid-cols-1 lg:grid-cols-2">
              {/* Imagen (oculta en móvil para priorizar formulario) */}
              <div className="hidden lg:block">
                <img
                  src={img_login}
                  className="w-full h-full object-cover"
                  alt="Imagen de login"
                />
              </div>

              {/* Formulario */}
              <div className="p-6 sm:p-8 lg:p-12 flex flex-col justify-center">
                {/* Header compacto con logo y badge */}
                <div className="flex flex-col items-center text-center mb-6">
                  <img
                    className="w-16 h-16 rounded-full mb-3"
                    src={img_logo}
                    alt="Logo"
                  />
                  <span className="inline-block text-xs font-semibold text-white px-4 py-1 rounded-full bg-gradient-to-r from-[#ff1049] to-[#ff7826]">
                    Bienvenido
                  </span>
                  <h1 className="mt-4 text-2xl sm:text-3xl font-bold text-gray-900">
                    Ingresa a tu cuenta
                  </h1>
                  <p className="mt-1 text-sm text-gray-500">
                    Usa tu correo y contraseña para continuar
                  </p>
                </div>

                {/* Form */}
                <form onSubmit={onSubmit} className="space-y-4">
                  <input type="hidden" name="remember" defaultValue="true" />

                  <div className="space-y-4">
                    <div>
                      <label
                        htmlFor="email-address"
                        className="block text-sm font-medium text-gray-700 mb-1"
                      >
                        Correo
                      </label>
                      <input
                        id="email-address"
                        name="email"
                        value={email}
                        onChange={onChange}
                        type="email"
                        autoComplete="email"
                        required
                        placeholder="tucorreo@ejemplo.com"
                        className="w-full rounded-lg px-4 py-3 text-gray-900 bg-gray-100 border border-gray-300 focus:border-[#ff1049] focus:ring-2 focus:ring-[#ff1049]/40 outline-none transition"
                      />
                    </div>

                    <div>
                      <label
                        htmlFor="password"
                        className="block text-sm font-medium text-gray-700 mb-1"
                      >
                        Contraseña
                      </label>
                      <input
                        id="password"
                        name="password"
                        value={password}
                        onChange={onChange}
                        type="password"
                        autoComplete="current-password"
                        required
                        placeholder="••••••••"
                        className="w-full rounded-lg px-4 py-3 text-gray-900 bg-gray-100 border border-gray-300 focus:border-[#ff1049] focus:ring-2 focus:ring-[#ff1049]/40 outline-none transition"
                      />
                    </div>
                  </div>

                  {/* CTA */}
                  <div className="pt-2">
                    <button
                      type="submit"
                      disabled={loading}
                      className="w-full rounded-lg bg-gradient-to-r from-[#ff1049] to-[#ff7826] px-6 py-3 text-white font-semibold shadow-sm hover:opacity-95 focus:outline-none focus:ring-2 focus:ring-[#ff1049]/40 focus:ring-offset-2 disabled:opacity-60 disabled:cursor-not-allowed transition"
                    >
                      {loading ? "Ingresando..." : "Ingresar"}
                    </button>
                  </div>

                  {/* Acciones secundarias 
                  <div className="flex items-center justify-between pt-2 text-sm">
                    <a
                      href="/forgot-password"
                      className="text-[#ff1049] hover:underline"
                    >
                      ¿Olvidaste tu contraseña?
                    </a>
                    <a
                      href="/register"
                      className="text-gray-500 hover:text-[#ff1049] transition"
                    >
                      Crear cuenta
                    </a>
                  </div>*/}
                </form>

                {/* Nota legal breve */}
                <p className="mt-6 text-[11px] text-center text-gray-400">
                  Al ingresar aceptas nuestros Términos y la Política de
                  Privacidad.
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
    </HomeLayout>
  );
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  loading: state.auth.loading,
});

export default connect(mapStateToProps, {
  login,
  refresh,
  check_authenticated,
  load_user,
})(Login);
